import {
  PublicClientApplication,
  IPublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { environment } from '@env';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.auth.clientId,
      authority: 'https://login.microsoftonline.com/582259a1-dcaa-4cca-b1cf-e60d3f045ecd',
      redirectUri: '/auth',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      tokenRenewalOffsetSeconds: 300,
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read'],
    },
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map([
      [`${environment.backend.url}/*`, [`api://${environment.auth.clientId}/access_as_user`]],
      [
        'https://graph.microsoft.com/v1.0/me/*',
        [
          {
            httpMethod: 'GET',
            scopes: ['user.read', 'profile'],
          },
        ],
      ],
    ]),
  };
}

export const provideMsalAuth: EnvironmentProviders = importProvidersFrom(MsalRedirectComponent);
